export function SimpleExclamationIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='2' height='12' viewBox='0 0 2 12' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M0.987539 0.75L0.977539 7.25M0.977539 11.25H0.987539'
        stroke='#D97706'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
